export default __webpack_public_path__ + "50960b3fca324a00ab5224d7c64d013e.svg";